export default "__VITE_ASSET__99991b71__"